import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import FileUpload from './components/FileUpload';
import Dashboard from './components/Dashboard';
import { Box, Container, Typography } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

function App() {
  const [tripData, setTripData] = useState(null);

  const handleFileUpload = (data) => {
    setTripData(data);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          padding: 2,
          backgroundColor: 'background.default',
        }}
      >
        <Container maxWidth="xl">
          <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ pt: 2, color: 'primary.main' }}>
            Trip Analyzer Dashboard
          </Typography>
          
          {!tripData ? (
            <FileUpload onFileUpload={handleFileUpload} />
          ) : (
            <Dashboard tripData={tripData} />
          )}
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default App;